import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LanguageContext } from '../../context/LanguageContext';

import styles from './Header.module.scss';

// Import des traductions 
import translations from '../../utils/translations/HeaderTranslations';

import LanguageSelector from "../../utils/LanguageSelector/LanguageSelector";

const Header = () => {

    // Utilisation du contexte de langue global
    const { language } = useContext(LanguageContext);

    // Accès simplifié aux traductions
    const t = translations[language] || translations.fr;

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    // const menuRef = useRef(null); // <-- Ref pour le menu (utilisé pour le refermer quand on clique sur le "vide")

    const handleNavigation = (event, path) => {
        event.preventDefault();
        navigate(path);
        setIsMenuOpen(false);
    };

    return (
        <>
        <header id="header" className={styles.header}>
            <div id="header-top" className={styles.headerTop}>
                <div className={styles.imgContainer}>
                    <img 
                        className={styles.logo} 
                        src="/assets/img/logo-hatanna-sirene-black.png" 
                        alt="Logo Hatanna" 
                        onClick={(e) => handleNavigation(e, '/')}
                    />
                </div>
                <div className={styles.titres}>
                    <h1 id="titre" className={styles.titre} onClick={(e) => handleNavigation(e, '/')}>Hatann'<span>App</span></h1>
                    <h2 id="soustitre" className={styles.sousTitre}>{t.appSubtitle}</h2>
                </div>
            </div>

            {/* Menu Hamburger */}
            <div id="menu-mobile" className={styles.menuMobile} onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <div className={`${styles.hamb} ${isMenuOpen ? styles.open : ''}`}>
                    <div className={styles.hambElem}></div>
                    <div className={styles.hambElem}></div>
                    <div className={styles.hambElem}></div>
                </div>
            </div>

            {/* Menu principal avec animation */}
            <nav id="menu-principal" className={`${styles.menuPrincipal} ${isMenuOpen ? styles.menuOpen : ''}`}>
                <ul className={styles.menu}>
                    <li><LanguageSelector /></li>
                    <li><a href="/" onClick={(e) => handleNavigation(e, '/')}>{t.homeScreen}</a></li>
                    {user && (
                        <>
                            <li><a href="/user-account" onClick={(e) => handleNavigation(e, '/user-account')}>{t.myAccount}</a></li>
                        
                            {user.role === "PARTNER" && (
                                <>
                                    <li><a href="/partner-panel" onClick={(e) => handleNavigation(e, '/partner-panel')}>{t.partnerCorner}</a></li>
                                    <div className={styles.spacer}></div>
                                </>
                            )}
                        </>
                    )}
                    <li><a href="/contact" onClick={(e) => handleNavigation(e, '/contact')}>{t.contactUs}</a></li>
                    <div className={styles.spacer}></div>
                    <li><a href="/conditions" onClick={(e) => handleNavigation(e, '/conditions')}>{t.termsOfUse}</a></li>
                    
                    {user ? (
                        <>
                            <div className={styles.spacer}></div>
                            {user.role === "ADMIN" && (
                                <>
                                    <li><a href="/admin-panel" onClick={(e) => handleNavigation(e, '/admin-panel')}>{t.adminPanel}</a></li>
                                    <div className={styles.spacer}></div>
                                </>
                            )}
                            <li><a href="/" onClick={(e) => { e.preventDefault(); logout(); setIsMenuOpen(false); }}>{t.logout}</a></li>
                        </>
                    ) : (
                        <li><a href="/login" onClick={(e) => handleNavigation(e, '/login')}>{t.login}</a></li>
                    )}
                </ul>
            </nav>
        </header> 

        {/* Overlay en dehors du header */}
        {isMenuOpen && (
            <div 
            className={styles.overlay} 
            onClick={() => setIsMenuOpen(false)}
            ></div>
        )}
        </>
    );
};

export default Header;
